import { Component, OnInit } from '@angular/core';
import { fuseAnimations } from '@fuse/animations';

@Component({
  selector: 'app-track-layout',
  template: '<router-outlet></router-outlet>', 
  styles: [],
  animations : fuseAnimations
})
export class TrackLayoutComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
